module.exports = __webpack_public_path__ + "media/images/flags/32/Seychelles-5445454a381491b55345770f905b1832.png";